<template>
	<div>
		<!-- Header -->
		<div class="py-7 py-lg-8 pt-lg-9 mb-8">
			<b-container>
				<b-row class="justify-content-center">
					<b-col cols="12" class="text-center">
						<h1>Choose the best plan for your business</h1>
					</b-col>
				</b-row>
			</b-container>
		</div>
		<!-- Page content -->
		<b-container class="mt--8 pb-5">
			<b-row class="justify-content-center">
				<b-col cols="12">
					<b-card-group class="pricing flex-column flex-md-row mb-3">
						<!-- Basic Package -->
						<b-card
							v-for="(pkg, index) in packages"
							:key="index"
							:class="pkg.package_type === 'Corporate' ? 'zoom-in bg-gradient-primary' : ''"
							:footer-class="pkg.package_type === 'Corporate' ? 'bg-gradient-primary' : ''"
							header-class="bg-transparent"
							body-class="px-5"
							class="card-pricing border-0 text-center mb-4"
						>
							<h4
								slot="header"
								class="text-uppercase ls-1 text-primary py-3 mb-0"
								:class="pkg.package_type === 'Corporate' ? 'text-white' : ''"
							>
								{{ pkg.package_type }} Package
							</h4>

							<div v-if="pkg.price === 0" class="display-2">FREE</div>
							<div v-else class="display-2" :class="pkg.package_type === 'Corporate' ? 'text-white' : ''">RM {{ pkg.price | moneyFormatter }}</div>

							<span v-if="pkg.price !== 0" :class="pkg.package_type === 'Corporate' ? 'text-white' : 'text-muted'">per Year</span>
							<ul class="list-unstyled my-4">

								<div v-for="(details, key) in pkg.package_details" :key="key">
									<li>
										<div>
											<i class="fas fa-check text-success"></i>
											<span class="pl-2"  :class="pkg.package_type === 'Corporate' ? 'text-white' : ''">{{ details }}</span>
										</div>
									</li>
								</div>
							</ul>

							<a slot="footer" href="#!" class="text-light">Request a demo</a>
						</b-card>
					</b-card-group>
				</b-col>
			</b-row>

			<b-row class="mt-8">
				<b-col cols="12">
					<b-table-simple responsive>
						<b-thead>
							<b-tr>
								<b-th>FEATURES</b-th>
								<b-th v-for="(pkg, index) in packages" :key="index" class="text-center"> {{ pkg.package_type }} Package</b-th>
							</b-tr>
						</b-thead>
						<b-tbody>
							<b-tr>
								<b-th colspan="4" class="text-center text-white" variant="dark">Dashboard Features</b-th>
							</b-tr>
							<b-tr v-for="(dashboard_feature, key) in packages[0].features.dashboard" :key="key">
								<b-td>{{ formatText(key) }}</b-td>
								<b-td v-for="(pkg, index) in packages" :key="index" class="text-center">
									<span v-if="pkg.features.dashboard[key] === true"><i class="fas fa-check text-success"></i></span>
									<span v-else-if="pkg.features.dashboard[key] === false">-</span>
									<span v-else>{{ pkg.features.dashboard[key] }}</span>
								</b-td>
							</b-tr>

							<b-tr>
								<b-th colspan="4" class="text-center text-white" variant="dark">CRM Features</b-th>
							</b-tr>
							<b-tr v-for="(crm_feature, key) in packages[0].features.crm_features" :key="key">
								<b-td>{{ formatText(key) }}</b-td>
								<b-td v-for="(pkg, index) in packages" :key="index" class="text-center">
									<span v-if="pkg.features.crm_features[key] === true"><i class="fas fa-check text-success"></i></span>
									<span v-else-if="pkg.features.crm_features[key] === false">-</span>
									<span v-else>{{ pkg.features.crm_features[key] }}</span>
								</b-td>
							</b-tr>

							<b-tr>
								<b-th colspan="4" class="text-center text-white" variant="dark">Customers List</b-th>
							</b-tr>
							<b-tr v-for="(customer_feature, key) in packages[0].features.customers_list" :key="key">
								<b-td>{{ formatText(key) }}</b-td>
								<b-td v-for="(pkg, index) in packages" :key="index" class="text-center">
									<span v-if="pkg.features.customers_list[key] === true"><i class="fas fa-check text-success"></i></span>
									<span v-else-if="pkg.features.customers_list[key] === false">-</span>
									<span v-else class="text-capitalize">{{ pkg.features.customers_list[key] }}</span>
								</b-td>
							</b-tr>

							<b-tr>
								<b-th colspan="4" class="text-center text-white" variant="dark">Loan Application</b-th>
							</b-tr>
							<b-tr v-for="(application, key) in packages[0].features.loan_application" :key="key">
								<b-td>{{ formatText(key) }}</b-td>
								<b-td v-for="(pkg, index) in packages" :key="index" class="text-center">
									<span v-if="pkg.features.loan_application[key] === true"><i class="fas fa-check text-success"></i></span>
									<span v-else-if="pkg.features.loan_application[key] === false">-</span>
									<span v-else class="text-capitalize">{{ pkg.features.loan_application[key] }}</span>
								</b-td>
							</b-tr>

							<b-tr>
								<b-th colspan="4" class="text-center text-white" variant="dark">Smart Financial Calculators</b-th>
							</b-tr>
							<b-tr v-for="(calculator, key) in packages[0].features.smart_calculators" :key="key">
								<b-td>{{ formatText(key) }}</b-td>
								<b-td v-for="(pkg, index) in packages" :key="index" class="text-center">
									<span v-if="pkg.features.smart_calculators[key] === true"><i class="fas fa-check text-success"></i></span>
									<span v-else-if="pkg.features.smart_calculators[key] === false">-</span>
									<span v-else class="text-capitalize">{{ pkg.features.smart_calculators[key] }}</span>
								</b-td>
							</b-tr>

							<b-tr>
								<b-th colspan="4" class="text-center text-white" variant="dark">Others</b-th>
							</b-tr>
							<b-tr>
								<b-td>Referral Link</b-td>
								<b-td v-for="(pkg, index) in packages" :key="index" class="text-center">
									<span v-if="pkg.features.referral_link" class="text-capitalize">{{ pkg.features.referral_link }}</span>
									<span v-else>-</span>
								</b-td>
							</b-tr>
						</b-tbody>
					</b-table-simple>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
import BaseTable from "@/components/BaseTable";

export default {
	name: "pricing-page",
	components: {
		BaseTable,
	},
	data() {
		return {
			packages: [
				{
					package_type: 'Basic',
					price: 0,
					package_details: [
						"Perfect for startups and small businesses.",
						"Get essential features like lead management and customer tracking.",
						"Monitor your leads, customers, and credit reports effortlessly.",
						"Best choice for getting started with without breaking the bank."
					],
					features: {
						dashboard: {
							leads_features: true,
							customer_management: true,
							credit_report: true,
							bank_comparison: false,
							credit_score_analysis: false,
							sales_performance_analytics: false,
							agent_score_cards: false
						},
						crm_features: {
							lead_management: true,
							bulk_lead_uploads: false,
							chat_features: false,
							smart_lead_routing: false,
							agent_performance_rating: false,
						},
						customers_list: {
							purchase_fintos_report: 'RM 36',
							financial_profiles_basket: false,
							secure_doc_management: false
						},
						loan_application: {
							mortgage_loan: 'Up to 5 eligible banks',
							refinance: false,
							property_platform_api: false,
							banker_app: false
						},
						smart_calculators: {
							legal_fees: false,
							mortgage: false,
						},
						referral_link: false,
						api_platform: ''
					}
				},
				{
					package_type: 'Corporate',
					price: 3999,
					package_details: [
						"Designed for established enterprises and corporate teams.",
						"Unlock the full potential of your CRM with comprehensive features.",
						"Analyze sales performance, generate credit score analysis, and more.",
						"Refinance options, property platform API, and banker app included.",
						"Benefit from a 30% discount on purchase fintos reports and free referral reports."
					],
					features: {
						dashboard: {
							leads_features: true,
							customer_management: true,
							credit_report: true,
							bank_comparison: true,
							credit_score_analysis: true,
							sales_performance_analytics: true,
							agent_score_cards: true
						},
						crm_features: {
							lead_management: true,
							bulk_lead_uploads: true,
							chat_features: true,
							smart_lead_routing: true,
							agent_performance_rating: true,
						},
						customers_list: {
							purchase_fintos_report: 'discount 50%',
							financial_profiles_basket: true,
							secure_doc_management: true
						},
						loan_application: {
							mortgage_loan: 'Up to 15 eligible banks',
							refinance: true,
							property_platform_api: true,
							banker_app: true
						},
						smart_calculators: {
							legal_fees: true,
							mortgage: true,
						},
						referral_link: 'free 30 report',
						api_platform: ''
					}
				},
				{
					package_type: 'Individual',
					price: 999,
					package_details: [
						"Tailored for individuals and freelancers.",
						"Access advanced tools like bulk lead uploads and chat features.",
						"Enjoy a 30% discount on purchase fintos reports.",
						"Streamline your workflow and stand out in your freelancing career."
					],
					features: {
						dashboard: {
							leads_features: true,
							customer_management: true,
							credit_report: true,
							bank_comparison: false,
							credit_score_analysis: false,
							sales_performance_analytics: false,
							agent_score_cards: false
						},
						crm_features: {
							lead_management: true,
							bulk_lead_uploads: true,
							chat_features: true,
							smart_lead_routing: false,
							agent_performance_rating: false,
						},
						customers_list: {
							purchase_fintos_report: 'discount 30%',
							financial_profiles_basket: true,
							secure_doc_management: true
						},
						loan_application: {
							mortgage_loan: 'Up to 10 eligible banks',
							refinance: true,
							property_platform_api: false,
							banker_app: false
						},
						smart_calculators: {
							legal_fees: false,
							mortgage: false,
						},
						referral_link: 'free 5 report',
						api_platform: ''
					}
				}
			]	
		};
	},
	methods: {
		formatText(str) {
			// Split the text by underscores and capitalize each word
			const words = str.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1));
			
			// Join the capitalized words with a space
			return words.join(' ');
		},
	}
};
</script>
<style></style>
